// OZ v5 custom errors — the payment token's reverts bubble up through escrow
// calls, so these must be present on BOTH ABIs for viem to decode them.
const TOKEN_ERRORS = [
  {
    type: "error",
    name: "ERC20InsufficientBalance",
    inputs: [
      { name: "sender", type: "address" },
      { name: "balance", type: "uint256" },
      { name: "needed", type: "uint256" },
    ],
  },
  {
    type: "error",
    name: "ERC20InsufficientAllowance",
    inputs: [
      { name: "spender", type: "address" },
      { name: "allowance", type: "uint256" },
      { name: "needed", type: "uint256" },
    ],
  },
  { type: "error", name: "SafeERC20FailedOperation", inputs: [{ name: "token", type: "address" }] },
];

export const ESCROW_ABI = [
  ...TOKEN_ERRORS,
  {
    type: "function",
    name: "fundDeal",
    stateMutability: "payable",
    inputs: [
      { name: "_signature", type: "bytes" },
      { name: "_token", type: "bytes32" },
      { name: "_timeToExpire", type: "uint256" },
      { name: "_payer", type: "address" },
      { name: "_escrowId", type: "string" },
      { name: "_paymentToken", type: "address" },
      { name: "_amount", type: "uint256" },
      { name: "_dealHash", type: "bytes32" },
    ],
    outputs: [],
  },
  {
    type: "function",
    name: "settleDeal",
    stateMutability: "nonpayable",
    inputs: [
      { name: "_signature", type: "bytes" },
      { name: "_token", type: "bytes32" },
      { name: "_timeToExpire", type: "uint256" },
      { name: "_escrowId", type: "string" },
      { name: "_payee", type: "address" },
      { name: "_toPayee", type: "uint256" },
      { name: "_toPayer", type: "uint256" },
    ],
    outputs: [],
  },
  {
    type: "function",
    name: "addFunds",
    stateMutability: "payable",
    inputs: [
      { name: "_signature", type: "bytes" },
      { name: "_token", type: "bytes32" },
      { name: "_timeToExpire", type: "uint256" },
      { name: "_escrowId", type: "string" },
      { name: "_amount", type: "uint256" },
    ],
    outputs: [],
  },
  {
    type: "function",
    name: "refundPartial",
    stateMutability: "nonpayable",
    inputs: [
      { name: "_signature", type: "bytes" },
      { name: "_token", type: "bytes32" },
      { name: "_timeToExpire", type: "uint256" },
      { name: "_escrowId", type: "string" },
      { name: "_amount", type: "uint256" },
    ],
    outputs: [],
  },
];

export const ERC20_ABI = [
  ...TOKEN_ERRORS,
  {
    type: "function",
    name: "approve",
    stateMutability: "nonpayable",
    inputs: [
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    outputs: [{ name: "", type: "bool" }],
  },
  {
    type: "function",
    name: "allowance",
    stateMutability: "view",
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" },
    ],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [{ name: "account", type: "address" }],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    type: "function",
    name: "decimals",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint8" }],
  },
];
